/* ==========================================================================
   KELE branch2 — el marco de las tarjetas.

   POR QUE HAY JS AQUI (y no solo CSS):
   El contorno tiene que coincidir al pixel con el recorte de la foto. Si el SVG
   se estira con preserveAspectRatio="none", la diagonal de la esquina deja de
   ser de 45 grados y el corte del marco no cae encima del corte de la imagen.
   La unica forma exacta es construir el path con el ancho y alto REALES de cada
   galeria y volverlo a calcular cuando cambia de tamano. Son 40 lineas y sirven
   para los 64 productos y para todos los que vengan: cero trabajo por pieza.

   El resto del sistema (revelado, costura, transicion) es CSS puro.
   ========================================================================== */
(function () {
  'use strict';

  var ORIGEN = 'León · MX';  // el sello que asoma al pasar el cursor
  var SVGNS = 'http://www.w3.org/2000/svg';
  var vistos = new WeakSet();

  // El chaflan NO se escribe aqui: se lee de --kf2-corte, que es la misma
  // variable con la que el CSS recorta la foto. Si estuviera en los dos lados,
  // al cambiarla por breakpoint el marco dejaria de caer encima del recorte.
  function corteDe(el) {
    var v = parseFloat(getComputedStyle(el).getPropertyValue('--kf2-corte'));
    return isFinite(v) && v > 0 ? v : 28;
  }

  // placa de talabarteria: esquina superior izquierda y inferior derecha cortadas
  function placa(w, h, c) {
    return 'M' + c + ' 0 L' + w + ' 0 L' + w + ' ' + (h - c) +
           ' L' + (w - c) + ' ' + h + ' L0 ' + h + ' L0 ' + c + ' Z';
  }

  function montar(card) {
    var gal = card.querySelector('.card-gallery');
    if (!gal) return;
    card.classList.add('kf2-card');

    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('class', 'kf2-marco');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('preserveAspectRatio', 'none');
    var base = document.createElementNS(SVGNS, 'path');
    base.setAttribute('class', 'kf2-base');
    var acc = document.createElementNS(SVGNS, 'path');
    acc.setAttribute('class', 'kf2-acc');
    svg.appendChild(base);
    svg.appendChild(acc);
    card.appendChild(svg);

    var sello = document.createElement('span');
    sello.className = 'kf2-sello';
    sello.setAttribute('aria-hidden', 'true');
    sello.textContent = ORIGEN;
    card.appendChild(sello);

    // La clase kf2-listo es la que enciende la transicion del trazo. Se APAGA
    // durante cada medida: si esta puesta, el cambio de --kf2-len (que pasa
    // cada vez que carga una foto y la galeria cambia de alto) se anima, el
    // dasharray salta y el dashoffset se queda atras, y por unos cuantos
    // cientos de milisegundos asoma un pedazo del contorno ambar en reposo.
    // Se vio en pantalla: diagonal y costado izquierdo pintados sin hover.
    var reloj = null;
    function medir() {
      card.classList.remove('kf2-listo');
      var r = gal.getBoundingClientRect();
      var w = Math.round(r.width), h = Math.round(r.height);
      if (!w || !h) return;
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      svg.style.height = h + 'px';
      var d = placa(w, h, corteDe(gal));
      base.setAttribute('d', d);
      acc.setAttribute('d', d);
      svg.style.setProperty('--kf2-len', acc.getTotalLength() + 'px');
      // el sello se sienta dentro de la foto, arriba del borde de abajo
      sello.style.top = (h - 34) + 'px';
      // setTimeout y no rAF: en una pestana en segundo plano rAF no corre y la
      // tarjeta se quedaria para siempre sin transicion.
      clearTimeout(reloj);
      reloj = setTimeout(function () { card.classList.add('kf2-listo'); }, 90);
    }
    medir();
    if (window.ResizeObserver) new ResizeObserver(medir).observe(gal);
  }

  // El titulo se parte en dos HERMANOS: el texto y la barra. No pueden estar
  // anidados, porque lo que esconde al texto (opacidad) se heredaria a la barra
  // y volveria a pasar lo de la primera version: la barra invisible.
  function revelar(h) {
    if (h.querySelector('.kf2-rev__t')) return;
    var texto = document.createElement('span');
    texto.className = 'kf2-rev__t';
    while (h.firstChild) texto.appendChild(h.firstChild);
    var barra = document.createElement('span');
    barra.className = 'kf2-rev__b';
    barra.setAttribute('aria-hidden', 'true');
    h.appendChild(texto);
    h.appendChild(barra);
    h.classList.add('kf2-rev');
  }

  // HERO EN VIDEO — el reel de estudio.
  //
  // POR QUE ESTO ES JS Y NO UN AJUSTE DEL TEMA (16-ago-2026):
  // hero.liquid SI acepta video (media_type_1 = 'video' + video_1), pero el
  // ajuste `video_1` rechazo las seis formas de referencia que probe contra
  // themeFilesUpsert — shopify://shop_videos/<archivo>, shopify://videos/...,
  // el gid, el id numerico — siempre con "must be a valid video shopify url",
  // y shopify.dev no publica el formato. Queda pendiente cambiarlo al ajuste
  // nativo si aparece la forma correcta.
  //
  // El respaldo de esto es bueno, no un parche: el tema sigue sirviendo el
  // banner como imagen. Si el JS no corre o el video no carga, el hero es el
  // que ya estaba. El banner solo se retira cuando el video YA tiene cuadro.
  // POR QUE ESTE ARCHIVO Y NO LA RENDITION DE SHOPIFY (16-ago-2026):
  // Carlos reporto que el video tardaba en arrancar. La rendition de Shopify de
  // 404x720 pesa 3.86 MB a 4.5 Mbps — muchisimo para un telon liso de 7 s con
  // poco movimiento. Re-encodado a mano queda en 0.62 MB, y ademas a MAYOR
  // resolucion (540x960). Seis veces menos.
  // Lo decisivo es `-movflags +faststart`: mueve el indice (moov) al principio
  // del archivo, para que el navegador pueda empezar a reproducir sin haberlo
  // bajado completo.
  var VIDEO_HERO = 'https://cdn.shopify.com/s/files/1/0746/6044/6339/files/kele-reel-web.mp4?v=1786916272';
  var POSTER_HERO = 'https://cdn.shopify.com/s/files/1/0746/6044/6339/files/preview_images/854f61c9bb2a4763b0989c62f7293900.thumbnail.0000000000.jpg';

  function heroVideo() {
    var wrap = document.querySelector('[id*="hero_kele"] .hero__media-wrapper');
    if (!wrap || wrap.querySelector('video')) return;
    var img = wrap.querySelector('img.hero__media');
    if (!img) return;

    var v = document.createElement('video');
    v.className = 'hero__media kf2-hero-video';
    // los dos: la propiedad para el motor y el atributo para el parser, que
    // iOS exige el atributo literal o no deja arrancar solo
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('autoplay', '');
    v.setAttribute('loop', '');
    v.loop = true;
    v.autoplay = true;
    v.preload = 'auto';
    v.poster = POSTER_HERO;
    v.setAttribute('aria-hidden', 'true');
    // 404x720 y no 1080: contenido en escritorio el video se ve a ~416 px de
    // ancho, asi que esta rendition cae casi 1:1 y pesa la mitad.
    v.src = VIDEO_HERO;

    // El banner se retira en cuanto HAY algo del reel que pintar. Antes solo
    // escuchaba `loadeddata`, y mientras el video bajaba se veia el banner
    // asomando por las franjas de los costados del reel contenido — el arco de
    // piedra a los lados de la modelo. El poster es un JPG del CDN que entra
    // mucho antes que el video: en cuanto carga, ya hay cuadro del reel y el
    // banner sobra. Si fallan los dos, el banner se queda, que es lo correcto.
    function listo() { wrap.classList.add('kf2-hero-listo'); }
    var poster = new Image();
    poster.onload = listo;
    poster.src = POSTER_HERO;
    v.addEventListener('loadeddata', listo, { once: true });

    wrap.appendChild(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* si el navegador no deja, se queda el banner */ });

    sonido(wrap, v);
  }

  // BOTON DE SONIDO. Arranca SIEMPRE en silencio, no por gusto: ningun navegador
  // deja que un video con audio se reproduzca solo. El boton solo quita el
  // silencio; si se pusiera con sonido de entrada, el autoplay se bloquea y el
  // hero se queda congelado.
  function sonido(wrap, v) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kf2-son';
    b.setAttribute('aria-pressed', 'false');
    b.setAttribute('aria-label', 'Activar sonido');

    // La perilla del switch, con el icono adentro. Solo se redibuja el icono:
    // la perilla es la misma para que la transicion del desplazamiento corra.
    var bola = document.createElement('span');
    bola.className = 'kf2-son__bola';
    b.appendChild(bola);

    var SVGNS2 = SVGNS;
    function icono(mudo) {
      bola.innerHTML = '';
      var s = document.createElementNS(SVGNS2, 'svg');
      s.setAttribute('viewBox', '0 0 24 24');
      s.setAttribute('aria-hidden', 'true');
      var bocina = document.createElementNS(SVGNS2, 'path');
      bocina.setAttribute('d', 'M5 9.5h3.4L13 5.5v13l-4.6-4H5z');
      s.appendChild(bocina);
      if (mudo) {
        var cruz = document.createElementNS(SVGNS2, 'path');
        cruz.setAttribute('d', 'M16.6 9.6l4.4 4.8M21 9.6l-4.4 4.8');
        s.appendChild(cruz);
      } else {
        var onda = document.createElementNS(SVGNS2, 'path');
        onda.setAttribute('d', 'M16.6 9.4a4 4 0 010 5.2');
        s.appendChild(onda);
      }
      bola.appendChild(s);
    }
    icono(true);

    b.addEventListener('click', function () {
      v.muted = !v.muted;
      b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
      b.setAttribute('aria-label', v.muted ? 'Activar sonido' : 'Silenciar');
      icono(v.muted);
      if (!v.muted) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
    });
    wrap.appendChild(b);
  }

  // GRUPOS PLEGABLES (Hombre: cinturones y carteras · Mujer: bolsos).
  // Cada grupo es una seccion product-list de verdad, con el id empezando en
  // "grupo_". Aqui solo se le pone la bisagra: el titulo se vuelve boton y la
  // cuadricula se guarda. Si el tema cambia y no aparecen las dos piezas que
  // busco, NO hago nada y el grupo se queda abierto — que es el estado seguro.
  var nGrupo = 0;
  function plegable(sec) {
    if (sec.classList.contains('kf2-plie')) return;
    var head = sec.querySelector('.section-resource-list__header');
    var lista = sec.querySelector('.resource-list');
    var h2 = head && head.querySelector('h2');
    if (!head || !lista || !h2) return;

    var caja = document.createElement('div');
    caja.className = 'kf2-plie__caja';
    caja.id = 'kf2-grupo-' + (++nGrupo);
    lista.parentNode.insertBefore(caja, lista);
    caja.appendChild(lista);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kf2-plie__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', caja.id);
    while (h2.firstChild) btn.appendChild(h2.firstChild);

    // cuantas piezas hay adentro: cerrado, es lo unico que lo anuncia
    var n = lista.querySelectorAll('.resource-list__item').length;
    if (n) {
      var cuenta = document.createElement('span');
      cuenta.className = 'kf2-plie__n';
      cuenta.textContent = n;
      btn.appendChild(cuenta);
    }

    var chev = document.createElementNS(SVGNS, 'svg');
    chev.setAttribute('class', 'kf2-plie__chev');
    chev.setAttribute('viewBox', '0 0 24 24');
    chev.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(SVGNS, 'path');
    p.setAttribute('d', 'M5 9l7 7 7-7');
    chev.appendChild(p);
    btn.appendChild(chev);

    h2.appendChild(btn);
    sec.classList.add('kf2-plie');
    btn.addEventListener('click', function () {
      var abierto = sec.classList.toggle('kf2-plie--abierto');
      btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
  }

  function barrer() {
    heroVideo();

    // primero las bisagras: asi el titulo del grupo ya es un boton cuando pasa
    // el revelado, y no le monto la animacion encima a un control
    var grupos = document.querySelectorAll('[id*="grupo_"]');
    for (var g = 0; g < grupos.length; g++) plegable(grupos[g]);

    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      if (vistos.has(cards[i])) continue;
      vistos.add(cards[i]);
      montar(cards[i]);
    }
    var hs = document.querySelectorAll('main h2');
    for (var j = 0; j < hs.length; j++) {
      if (vistos.has(hs[j])) continue;
      vistos.add(hs[j]);
      // el titulo de un grupo es un control, no un encabezado de lucimiento
      if (hs[j].closest('.kf2-plie')) continue;
      revelar(hs[j]);
    }
  }

  function arrancar() {
    barrer();
    // El tema mete tarjetas despues (carrusel, filtros, quick add). Se vuelve a
    // barrer, pero agrupado en un frame para no correr en cada mutacion suelta.
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; barrer(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
